/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from 'primereact/checkbox';
// import { Captcha } from 'primereact/captcha';
import { baseURL } from '../Config';
import { loginAction } from '../redux/actions/authAction';
import { handleEncryptData } from '../services/EncryptionService';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import sideRightImg from '../assets/images/side_right.png';
import logo from '../assets/images/ICT-Logo-V4-1-1 1 (1).png';

const Login = () => {
    const [tokenn, setTokenn] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const resetPassword = (e) => {
        e.preventDefault();
        navigate('/reset-password');
    };
    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },

        validate: (data) => {
            let errors = {};

            if (!data.email) {
                errors.email = 'Email is required.';
            }
            if (!data.password) {
                errors.password = 'Password is required.';
            }

            return errors;
        },

        onSubmit: async (data) => {
            try {
                const response = await dispatch(loginAction(data));
                console.log('Login Response:', response);

                if (response?.success === true && response?.data?.token) {
                    // Store token in sessionStorage
                    const token = response.data.token;

                    sessionStorage.setItem('token', token);
                    sessionStorage.setItem('refreshToken', response?.data?.refreshToken);

                    // Store other data
                    localStorage.setItem('tokenn', 'true');
                    localStorage.setItem('id', response?.data?.id);
                    localStorage.setItem('name', response?.data?.name);
                    localStorage.setItem('roleName', response?.data?.roleName);

                    // Set user data in sessionStorage
                    sessionStorage.setItem(
                        'userData',
                        JSON.stringify({
                            id: response?.data?.id,
                            roleName: response?.data?.roleName
                        })
                    );

                    setTokenn(true);
                } else {
                    console.error('Invalid response format or missing token:', response);
                }
            } catch (error) {
                console.error('Login error:', error);
            }
        }
    });

    useEffect(() => {
        if (tokenn) {
            navigate('/');
        }
    }, [tokenn, navigate]);

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="grid flex justify-content-between login__screen">
            <div className="col-5 m-auto input_section_login">
                <div className=" login__card">
                    <div className="flex logo-container" style={{ justifyContent: 'center' }}>
                        <img src={logo} style={{ height: '95px', width: '230px' }} alt="Logo" />
                    </div>

                    <form onSubmit={formik.handleSubmit}>
                        <div className="flex flex-column">
                            <div className="flex align-items-center justify-content-center my-4 logo-container">
                                <p className="Signin__Heading">Log In to the System</p>
                            </div>
                            <div className="form-container">
                                <div className="flex flex-column w-12 mt-4">
                                    <label htmlFor="email" className="pb-2 font-semibold">
                                        Email
                                    </label>
                                    <span className="p-input-icon-left">
                                        <i className="fa fa-envelope ml-1"></i>
                                        <InputText
                                            id="email"
                                            className={`Login__Input pl-6 w-full ${formik.touched.email && formik.errors.email ? 'is-invalid' : ''}`}
                                            name="email"
                                            value={formik.values.email}
                                            onChange={formik.handleChange}
                                            autoFocus
                                            style={{ marginBottom: '0.25rem', padding: '0.75rem' }}
                                        />
                                    </span>
                                    <div className="error-container" style={{ height: '1.5rem', marginTop: '0.25rem' }}>
                                        {getFormErrorMessage('email')}
                                    </div>
                                </div>
                                <div className="flex flex-column w-12 mt-4">
                                    <label htmlFor="password" className="pb-2 font-semibold">
                                        Password
                                    </label>
                                    <span className="p-input-icon-left">
                                        <i className="fa fa-lock ml-1"></i>
                                        <InputText
                                            id="password"
                                            className={`Login__Input pl-6 w-full ${formik.touched.password && formik.errors.password ? 'is-invalid' : ''}`}
                                            name="password"
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                            type="password"
                                            style={{ marginBottom: '0.25rem', padding: '0.75rem' }}
                                        />
                                    </span>
                                    <div className="error-container" style={{ height: '1.5rem', marginTop: '0.25rem' }}>
                                        {getFormErrorMessage('password')}
                                    </div>
                                </div>
                                <div className="flex flex-column w-12 mt-3 mb-2">
                                    {/* <p className="text-right forget-password">Forgot Password?</p> */}
                                    {/* <span className="text-right forget-password hover:underline mb-2" onClick={resetPassword}>
                                        Forgot Password?
                                    </span> */}
                                </div>

                                {/* <div className="button-container flex justify-content-center align-items-center mt-4 mb-5"> */}
                                <Button type="submit" label="Login" className="Login__Button1" />
                                {/* </div> */}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className="col-4 my-4 image__section" style={{ height: '95vh', width: '50vw' }}>
                <img src={sideRightImg} style={{ height: '95vh', width: '50vw' }} className="mr-4" alt="Side Image" />
            </div>
        </div>
    );
};

export default Login;
